/**
 * Shared constants
 * Used by both API and Admin frontend
 */

export const USER_ROLES = {
  SUPERADMIN: 'superadmin',
  SUPPLIER_ADMIN: 'supplier_admin',
  SUPPLIER_USER: 'supplier_user',
} as const;

export const USER_STATUS = {
  ACTIVE: 'active',
  PENDING_APPROVAL: 'pending_approval',
  REJECTED: 'rejected',
} as const;

// Approval gate on a supplier-admin invitation (the invite email is held until
// a super admin approves). Null = no approval required (super-admin invite).
export const INVITATION_APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type InvitationApprovalStatus =
  (typeof INVITATION_APPROVAL_STATUS)[keyof typeof INVITATION_APPROVAL_STATUS];

export const CLOSURE_TYPES = {
  SCREW_CAP: 'screw_cap',
  CORK: 'cork',
} as const;

export const PACKING_FORMATS = {
  CASES_OF_12: 'cases_of_12',
  OTHER: 'other',
} as const;

export const API_ENDPOINTS = {
  // Auth
  AUTH_LOGIN: '/api/auth/login',
  AUTH_LOGOUT: '/api/auth/logout',
  AUTH_ME: '/api/auth/me',
  AUTH_REFRESH: '/api/auth/refresh',

  // Suppliers
  SUPPLIERS: '/api/suppliers',
  SUPPLIER: (id: number) => `/api/suppliers/${id}`,

  // Products
  BULK_WINES: '/api/products/bulk-wines',
  CLEAN_SKINS: '/api/products/clean-skins',
  FRUIT: '/api/products/fruit',

  // Vineyards
  VINEYARDS: '/api/vineyards',
  VINEYARD: (id: number) => `/api/vineyards/${id}`,

  // Reference data
  COUNTRIES: '/api/reference/countries',
  REGIONS: '/api/reference/regions',
  SUB_REGIONS: '/api/sub-regions',
  VARIETIES: '/api/reference/varieties',
  BOTTLE_TYPES: '/api/reference/bottle-types',
  CLOSURE_TYPES: '/api/reference/closure-types',
  PACKING_TYPES: '/api/reference/packing-types',

  // Users
  USERS: '/api/users',
  USER: (id: number) => `/api/users/${id}`,
} as const;

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_TIMEOUT = 10000; // 10 seconds
